import React, { useState } from 'react';
import './SmallBagsViewSelector.css';

const SmallBagsViewSelector = ({ onViewChange, currentView }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedView, setSelectedView] = useState(currentView || 'all');

  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  const handleApply = () => {
    onViewChange(selectedView);
    setIsOpen(false);
  };

  return (
    <div className="small-bags-view-selector-container">
      <button
        className="btn btn__white_g small-bags-view-btn"
        onClick={toggleDropdown}
      >
        Change the View {isOpen ? '▲' : '▼'}
      </button>
      {isOpen && (
        <div className="small-bags-view-dropdown">
          <div className="view-option">
            <input
              type="radio"
              id="view-all"
              name="view"
              value="all"
              checked={selectedView === 'all'}
              onChange={() => handleViewChange('all')}
            />
            <label htmlFor="view-all">Show All</label>
          </div>
          <div className="view-option">
            <input
              type="radio"
              id="view-demand"
              name="view"
              value="demand"
              checked={selectedView === 'demand'}
              onChange={() => handleViewChange('demand')}
            />
            <label htmlFor="view-demand">Show Demand</label>
          </div>
          <div className="view-option">
            <input
              type="radio"
              id="view-left"
              name="view"
              value="left"
              checked={selectedView === 'left'}
              onChange={() => handleViewChange('left')}
            />
            <label htmlFor="view-left">Show Left</label>
          </div>
          <div className="view-option">
            <input
              type="radio"
              id="view-left-pp"
              name="view"
              value="left_pp"
              checked={selectedView === 'left_pp'}
              onChange={() => handleViewChange('left_pp')}
            />
            <label htmlFor="view-left-pp">Show Left + PP</label>
          </div>
          <button
            className="btn btn__green apply-btn"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default SmallBagsViewSelector;